import { endpoint, env, getAuthToken, handleUnauthorized } from '@eruvaka/web-pondlogs-base';
const api = (path) => endpoint(env.apiBaseUrl, path);
const handleError = async (res, fallback) => {
    if (res.status === 401) {
        handleUnauthorized();
        throw new Error('Unauthorized');
    }
    let message = fallback;
    try {
        const body = (await res.json());
        message = body.message ?? body.error ?? fallback;
    }
    catch {
        /* ignore parse errors */
    }
    throw new Error(message);
};
const authFetch = async (url, options = {}) => {
    const token = getAuthToken();
    return fetch(url, {
        ...options,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
    });
};
// ── Preferences API ────────────────────────────────────────────────────────────
export const fetchPreferences = async () => {
    const res = await authFetch(api('/api/v3/preferences'));
    if (!res.ok)
        return handleError(res, 'Failed to fetch preferences');
    const body = (await res.json());
    return body.data;
};
export const updatePreferences = async (payload) => {
    const res = await authFetch(api('/api/v3/preferences'), {
        method: 'PUT',
        body: JSON.stringify(payload),
    });
    if (!res.ok)
        return handleError(res, 'Failed to update preferences');
    const body = (await res.json());
    return body.data;
};
export const resetPreferences = async (section = 'all') => {
    const res = await authFetch(api('/api/v3/preferences/reset'), {
        method: 'POST',
        body: JSON.stringify({ section }),
    });
    if (!res.ok)
        return handleError(res, 'Failed to reset preferences');
    const body = (await res.json());
    return body.data;
};
// ── Advanced Monitoring Rules API ──────────────────────────────────────────────
export const fetchAdvancedRules = async () => {
    const res = await authFetch(api('/api/v3/advanced-rules'));
    if (!res.ok)
        return handleError(res, 'Failed to fetch rules');
    const body = (await res.json());
    return body.data;
};
export const createAdvancedRule = async (payload) => {
    const res = await authFetch(api('/api/v3/advanced-rules'), {
        method: 'POST',
        body: JSON.stringify(payload),
    });
    if (!res.ok)
        return handleError(res, 'Failed to create rule');
    const body = (await res.json());
    return body.data;
};
export const updateAdvancedRule = async (ruleId, payload) => {
    const res = await authFetch(api(`/api/v3/advanced-rules/${ruleId}`), {
        method: 'PUT',
        body: JSON.stringify(payload),
    });
    if (!res.ok)
        return handleError(res, 'Failed to update rule');
    const body = (await res.json());
    return body.data;
};
export const toggleAdvancedRule = async (ruleId, isActive) => {
    const res = await authFetch(api(`/api/v3/advanced-rules/${ruleId}/toggle`), {
        method: 'PATCH',
        body: JSON.stringify({ isActive }),
    });
    if (!res.ok)
        return handleError(res, 'Failed to toggle rule');
};
export const deleteAdvancedRule = async (ruleId) => {
    const res = await authFetch(api(`/api/v3/advanced-rules/${ruleId}`), { method: 'DELETE' });
    if (!res.ok)
        return handleError(res, 'Failed to delete rule');
};
